<template>
  <el-container style="width: 100%;height: 100%;display: flex;flex-direction: column;">
    <el-row style="width: 100%;height: 100%;display: flex;flex-direction: row;">
      <el-aside style="height: 100%;width: 250px;margin-right: 1px;background-color: #ffffff;">
        <el-row class="doc-tree-top">
          <el-input style='width: 100%; border: none; outline: none' class="filter-search" placeholder="输入关键字搜索" prefix-icon="zy-icon-search" v-model="filterName"/>
        </el-row>
        <el-tree :data="treeData" :props="defaultProps" @node-click="handleNodeClick" node-key='id' :filter-node-method="filterNode"
                 :default-expanded-keys="expandKeys" highlight-current ref="tree" class="aside-tree">
          <span slot-scope="{ node, data }">
            <i class="zy-icon-building"></i>
            <span>{{ node.label }}</span>
          </span>
        </el-tree>
      </el-aside>
      <el-main style="overflow-y: hidden;font-size: 14px;width: calc(100% - 251px);height: 100%;background-color: #ffffff;">
        <el-row class="tt-input" style="width: 100%;height: 48px;line-height: 48px;color: rgb(127, 127, 127);text-align: left;">
          <span style="margin-left: 24px;">时间：</span>
          <el-radio-group v-model="radio" @change="selBack" style="margin-left: 8px;" size="small">
            <el-radio-button label="年"></el-radio-button>
            <el-radio-button label="月"></el-radio-button>
          </el-radio-group>
          <el-date-picker v-model="monthDate" style="width: 140px;margin-left: 16px" :type="type"
                          placeholder="选择日期" :value-format="format" :clearable="false"/>
          <el-button class="search-btn-blue" style="margin-left: 16px;" @click="getChartData" type="primary" size="mini">查询</el-button>
        </el-row>
        <el-row style="background-color: #fff;width: 100%; height: 1px;"></el-row>
        <el-row style="overflow-y: auto;height: calc(100% - 49px);width: 100%;">
          <el-row style="height: calc(50% - 1px);width: 100%;">
            <el-row style="background-color: rgba(2, 124, 247, 0.8);width: 100%; height: 48px;">
              <span style="text-align: left;height: 48px;line-height: 48px;margin-left: 24px;color: rgb(247, 247, 247);display: flex;">标煤分析</span>
            </el-row>
            <el-col style="width: 100%;height: calc(100% - 48px);display: flex;">
              <el-col style="width: 65%;height: 100%;">
                <common-charts :init-options="initOptions" class="electric-parameter-charts"
                               :index="200" :key="timestamp" :options="dataData1" autoresize :style="{'height': ((bgSize.height - 195) / 2) + 'px', 'width': (13 * bgSize.width / 20 - 281) + 'px'}" />
              </el-col>
              <el-col style="width: 35%;height: 100%;">
                <common-charts :init-options="initOptions1" class="new-electric-parameter-charts"
                               :index="202" :key="timestamp" :options="dataData2" autoresize :style="{'height': ((bgSize.height - 195) / 2) + 'px', 'width': (7 * bgSize.width / 20 - 155) + 'px'}" />
              </el-col>
            </el-col>
          </el-row>
          <el-row style="height: 1px;width: 100%;background-color: #FFF" />
          <el-row style="height: calc(50% - 1px);width: 100%;" class="table">
            <el-row style="background-color: rgba(2, 124, 247, 0.8);width: 100%; height: 48px;">
              <el-menu :default-active="0" class="horizontal-menu" @select="panelSelect"
                       mode="horizontal" unique-opened background-color="rgba(0, 0, 0, 0)" text-color="rgba(242, 242, 242, 1)">
                <el-menu-item class="horizontal-menu-item" :key="0" :index="0">
                  <span style="font-size: 14px;">碳排放分析</span>
                </el-menu-item>
                <el-menu-item class="horizontal-menu-item" :key="1" :index="1">
                  <span style="font-size: 14px;">说明</span>
                </el-menu-item>
              </el-menu>
            </el-row>
            <el-col style="width: 100%;height: calc(100% - 48px);display: flex;">
              <el-col v-show="selPanel === 0" style="width: 65%;height: 100%;">
                <common-charts :init-options="initOptions2" class="electric-parameter-charts"
                             :index="203" :key="timestamp" :options="dataData3" autoresize :style="{'height': ((bgSize.height - 195) / 2) + 'px', 'width': (13 * bgSize.width / 20 - 281) + 'px'}" />
              </el-col>
              <el-col v-show="selPanel === 0" style="width: 30%;height: 100%;text-align: left;margin-left: 5%;">
                <el-row style="height: 96px;width: 100%;line-height: 96px;font-size: 16px;">
                  <el-col style="width: 50%;">
                    合计(t)：<span style="font-size: 24px;">{{carbonSum}}</span>
                  </el-col>
                  <el-col style="width: 50%;">
                    年度配额(t)：<span style="font-size: 24px;">{{carbonLimit}}</span>
                  </el-col>
                </el-row>
                <el-row style="height: 96px;width: 100%;line-height: 96px;font-size: 16px;">
                  占比：<span :style="{'font-size': '24px', 'color': ratioFlag === 2 ? '#FAAA00' : ratioFlag === 1 ? '#FF0000' : ''}">{{carbonRatio}}</span>
                </el-row>
              </el-col>
              <el-col v-show="selPanel === 1" style="width: 99%;height: 100%;text-align: left;margin-left: 1%;font-size: 14px;">
                <el-row style="height: 32px;line-height: 32px;margin-top: 8px;">请确保年度碳排放总量不要超过配额数，否则存在罚款风险。</el-row>
                <el-row style="height: 32px;line-height: 32px;">未使用完的配额可以通过碳交易平台进行交易：</el-row>
                <el-row style="height: 32px;line-height: 32px;">
                  <a href="https://www.bjets.com.cn/" target="_blank">北京:https://www.bjets.com.cn/</a>
                </el-row>
                <el-row style="height: 32px;line-height: 32px;">
                  <a href="https://www.cneeex.com/" target="_blank">上海:https://www.cneeex.com/</a>
                </el-row>
                <el-row style="height: 32px;line-height: 32px;">
                  <a href="http://www.cnemission.com/" target="_blank">广州:http://www.cnemission.com/</a>
                </el-row>
                <el-row style="height: 32px;line-height: 32px;">
                  <a href="https://www.chinatcx.com.cn/" target="_blank">天津:https://www.chinatcx.com.cn/</a>
                </el-row>
                <el-row style="height: 32px;line-height: 32px;">
                  <a href="http://www.cerx.cn/" target="_blank">深圳:http://www.cerx.cn/</a>
                </el-row>
                <el-row style="height: 32px;line-height: 32px;">
                  <a href="http://www.hbets.cn/" target="_blank">湖北:http://www.hbets.cn/</a>
                </el-row>
                <el-row style="height: 32px;line-height: 32px;">
                  <a href="https://tpf.cqggzy.com/" target="_blank">重庆:https://tpf.cqggzy.com/</a>
                </el-row>
              </el-col>
            </el-col>
          </el-row>
        </el-row>
      </el-main>
    </el-row>
  </el-container>
</template>

<script>
import DateUtils from "../../../utils/DateUtils";
import CommonCharts from "../../common/chart/CommonCharts";
import buildCommonConfig from "../../../config/chart/config_common_line";
import buildCircleConfig from "../../../config/chart/config_common_circle";
export default {
  name: "ProtectAnalyse",
  components: {CommonCharts},
  data() {
    return {
      radio: '月',
      initOptions: {
        renderer: 'canvas'
      },
      initOptions1: {
        renderer: 'canvas'
      },
      initOptions2: {
        renderer: 'canvas'
      },
      timestamp: 0,
      chartData: {},
      circleData: {},
      lineData: {},
      selNode: '',
      treeData: [],
      expandKeys: [],
      defaultProps: {
        children: 'childNode',
        label: 'name'
      },
      type: 'month',
      dateType: 2,
      startDate: DateUtils.getYesterday().Format('yyyy-MM'),
      monthDate: new Date().Format('yyyy-MM'),
      format: 'yyyy-MM',
      energyItem: [{'id': '1', 'name': '电'}, {'id': '2', 'name': '水'}, {'id': '11', 'name': '气'}, {'id': '12', 'name': '汽'}],
      bgSize: {'width': window.innerWidth, 'height': window.innerHeight},
      filterName: '',
      unit: 'kWh',
      media: '1',
      tableProps: [
        {prop: "dataName", label: "表计", sortable: false},
        {prop: "energySum", label: "总用量", sortable: true},
        {prop: "energyAvg", label: "平均用量", sortable: true}
      ],
      tableData: [],
      checkedKey: '',
      isMulti: false,
      monthData: {},
      dataData1: {},
      dataData2: {},
      dataData3: {},
      carbonLimit: '',
      carbonSum: '',
      carbonRatio: '',
      ratioFlag: 0,
      selPanel: 0
    }
  },
  created() {
    this.getTree('1')
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.bgSize.width = window.innerWidth
      this.bgSize.height = window.innerHeight
      this.timestamp = new Date().getTime()
    })
  },
  watch: {
    filterName(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    panelSelect(val) {
      this.selPanel = val
    },
    getTree() {
      this.$api.systemManage.getSiteTree().then(res => {
        this.treeData = res.data
        if (this.treeData && this.treeData.length > 0) {
          this.selNode = this.getLeafNode(this.treeData[0]);
          this.checkedKey = this.selNode.id.split(',')
          this.$refs.tree.setCheckedKeys([this.selNode['id']], true)
          let nodeIdName = 'id';
          this.$nextTick(function () {
            this.setTreeCurrent(this.selNode[nodeIdName], 1);
          })
        }
      })
    },
    handleNodeClick(cNode, node) {
      this.selNode = cNode;
      this.getChartData()
    },
    getLeafNode(pNode) {
      let leafNode = pNode;
      if (pNode.childNode && pNode.childNode.length > 0) {
        leafNode = this.getLeafNode(pNode.childNode[0]);
      }
      return leafNode;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data['name'].indexOf(value) !== -1;
    },
    setTreeCurrent(key, time) {
      if (time > 10) throw new Error('没有找到 树组件');
      let tree = this.$refs.tree;
      if (tree) {
        tree.setCurrentKey(key);
        this.expandKeys.push(key);
        let node = tree.getNode(key);
        if (key !== -1) tree.$emit("node-click", node.data, node, tree);
      } else {
        this.setTreeCurrent(key, time + 1)
      }
    },
    selBack(val) {
      if(val === '年') {
        this.dateType = 3
        this.type = 'year'
        this.monthDate = new Date().Format('yyyy')
        this.format = 'yyyy'
      }
      if(val === '月') {
        this.dateType = 2
        this.type = 'month'
        this.monthDate = new Date().Format('yyyy-MM')
        this.format = 'yyyy-MM'
      }
      if(val === '日') {
        this.dateType = 1
        this.type = 'date'
        this.monthDate = new Date().Format('yyyy-MM-dd')
        this.format = 'yyyy-MM-dd'
      }
      this.getChartData()
    },
    getChartData() {
      let params = {
        'id': this.selNode.id,
        'energy': this.media,
        'dataDate': this.monthDate,
        'dateType': this.dateType
      }
      this.$api.energyAnalyse.getProtectCurve(params).then(res => {
        this.carbonSum = res.data.carbonSum
        this.carbonLimit = res.data.carbonLimit
        this.carbonRatio = res.data.carbonRatio
        this.ratioFlag = res.data.ratioFlag
        let xAxis1 = res.data.dataName
        let data1 = [{
          type: 'bar',
          data: res.data.dataData1.split(","),
          markPoint: {
            data: [
              {type: 'max', name: '最大值', itemStyle: {color: '#FF0000'}},
              {type: 'min', name: '最小值', itemStyle: {color: '#00FF00'}}
            ]
          }
        }]
        this.dataData1 = buildCommonConfig('', xAxis1, data1, 0, 'kg')
        let data2 = res.data.pieData
        this.dataData2 = buildCircleConfig(data2, '标煤', 't');
        let xAxis3 = res.data.dataName
        let data3 = [{
          type: 'bar',
          data: res.data.dataData2.split(","),
          markPoint: {
            data: [
              {type: 'max', name: '最大值', itemStyle: {color: '#FF0000'}},
              {type: 'min', name: '最小值', itemStyle: {color: '#00FF00'}}
            ]
          }
        }]
        this.dataData3 = buildCommonConfig('', xAxis3, data3, 0, 'kg')
        this.timestamp = new Date().getTime();
      })
    }
  }
}
</script>

<style scoped>
  .doc-tree-top{
    display: inline-flex;
    align-items: center;
    height: 49px;
    width: 250px;
    border-bottom: 1px solid #fff;
  }
  .electric-parameter-charts{
    width: 100%;
    margin-top: 0;
  }
  .new-electric-parameter-charts{
    width: 100%;
    margin-top: 0;
  }
  /*.table /deep/ .el-table tr {*/
  /*  background-color: transparent!important;*/
  /*}*/
  .table /deep/ .el-table th {
    background-color: rgba(2, 124, 247, 0.2);
    border-top: 0;
  }
  /*.table /deep/ .el-table--enable-row-transition .el-table__body td, .el-table .cell{*/
  /*  background-color: transparent;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/EnergyAnalyse/ProtectAnalyse.vue